import React, { useEffect } from 'react';
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { navItems } from "./nav-items";
import { useTheme } from './lib/theme';
import ErrorBoundary from './components/ErrorBoundary';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';

const queryClient = new QueryClient();

const App = () => {
  const { theme } = useTheme(); // This will initialize the theme

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <UserPreferencesProvider>
          <TooltipProvider>
            <Toaster />
            <BrowserRouter>
              <Routes>
                {navItems.map(({ to, page }) => (
                  <Route key={to} path={to} element={page} />
                ))}
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </UserPreferencesProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
